export const discreteStateColors = ['brown', 'blue', 'violet', 'orange', 'pink', 'teal', 'purple', 'yellow'];
export const anomalyColors = ['green', 'red'];
